import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import QuoteEntryContainer from '../../../components/componentsControlTower/QuoteEntry/QuoteEntryContainer';

class ctrlTwrQuoteEntryView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <QuoteEntryContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} organizationSelection={this.props.organizationSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrQuoteEntryView;
